import styled, { css } from 'styled-components';
import { animated } from '@react-spring/web';

import { Chevron } from '@solent-university/solent-icons';

export const EmblaCarousel = styled.div`
    ${({ theme }) => css`
        overflow: hidden;
        padding-top: 2rem;

        @media ${theme.breakpoints.medium.media} {
            padding: 1rem 0 0.1rem 0.1rem;
        }
    `}
`;

export const EmblaContainer = styled.div`
    display: flex;
`;

export const List = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    height: 100%;
    flex: 0 0 100%;

    @media ${({ theme }) => theme.breakpoints.xlarge.media} {
        gap: 1.5rem;
    }
`;

export const Item = styled.li`
    display: inline-flex;
    justify-content: center;
`;

export const ControlsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2rem 0 1rem;
`;

export const Button = styled.button<{ $previous?: boolean }>`
    ${({ $previous }) => css`
        background: transparent;
        border: none;
        margin: 0;
        line-height: 1;
        padding: 0 0.5rem;

        &:hover {
            cursor: pointer;
            transform: ${$previous ? 'scaleX(-1) scale(1.05)' : 'scale(1.05)'};
        }

        &:focus {
            transform: ${$previous ? 'scaleX(-1) scale(1.05)' : 'scale(1.05)'};
        }

        ${$previous &&
        css`
            transform: scaleX(-1);
        `}
    `}
`;

export const Icon = styled(animated(Chevron))`
    ${({ theme }) => css`
        color: ${theme.colors.secondary.hex};
        background: ${theme.colors.tertiary.hex};
        height: 2rem;
        width: 2rem;
        padding: 0.5rem;
        border-radius: 50%;
    `}
`;

export const NavList = styled.ol`
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0 0.5rem;
`;

export const NavItem = styled.li`
    padding: 0 0.25rem;
    display: block;
`;
